import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { BetaRewards } from './views/BetaRewards';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<BetaRewards />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.BetaRewards)
	.build();

export default Layout;
